var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPillar3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 51.8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M49.3 32h2.5v14.8h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M54.2 37h2.5v4.9h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M0 37h2.5v4.9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M9.9 27.1h2.5v24.6H9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M46.8 12.3c-12.2 0-22.2 9.9-22.2 22.2h17.3v-8.6c0-.7.6-1.2 1.2-1.2H48c.7 0 1.2.6 1.2 1.2v3.7H53c.7 0 1.2.6 1.2 1.2v3.7h3.7c.7 0 1.2.6 1.2 1.2v7.4c0 .7-.6 1.2-1.2 1.2h-3.7V48c0 .7-.6 1.2-1.2 1.2h-3.7v2.5h11.5C66 47.6 69 41.2 69 34.5c0-12.2-9.9-22.2-22.2-22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M4.9 32h2.5v14.8H4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M44.4 27.1h2.5v24.6h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M57.9 0v12.5c-1.2-.6-2.4-1.1-3.7-1.5V4.9c0-.7-.6-1.2-1.2-1.2H40.7c-.7 0-1.2.6-1.2 1.2V11c-1.3.4-2.5.9-3.7 1.5V0h22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M14.8 37h27.1v4.9H14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M32.9 51.8h9v-7.4H27c1.4 2.8 3.4 5.3 5.9 7.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillar3);
export default __webpack_public_path__ + "static/media/pillar3.77c355e3431f7fcd7522ba061a4fe53a.svg";
export { ForwardRef as ReactComponent };